import {ReactElement} from "react";
import useProjectContext from "../../../services/context/project/use-project-context.ts";
import Button, {ButtonProps} from "../button";
import ProjectLockStatus from "../../../models/enums/project-lock-status.ts";
import useProjectLockDialogShower
    from "@/pages/takeoff/context/project-lock-dialog-shower/use-project-lock-dialog-shower.ts";

interface LockDependentButtonProps extends ButtonProps {
    disabled?: boolean,
}

const ButtonLockDependent= ({variant = 'primary', size = 'sm', disabled = false, type = 'button', className, onClick, ...props }: LockDependentButtonProps): ReactElement => {
    const { projectLockStatus } = useProjectContext();
    const isOwned = projectLockStatus === ProjectLockStatus.LOCK_OWNED;
    const { setShowLockDialog } = useProjectLockDialogShower();

    return (
        <Button
            title={isOwned ? '' : 'Projet verrouillé'}
            className={className}
            variant={variant}
            size={size}
            disabled={disabled}
            type={type}
            onClick={(event) => {
                if (isOwned) {
                    onClick?.(event);
                } else {
                    setShowLockDialog(true);
                }
            }}
            {...props}
        />
    )
}

export default ButtonLockDependent;